import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'layout.resize-handle.aria-label': {
    id: 'layout.resize-handle.aria-label',
    defaultMessage: 'Resize side panel',
    description: 'Aria label for the resize handle that allows resizing the side panel'
  }
});
